/* eslint-disable class-methods-use-this */
import { AxiosResponse } from 'axios';
import { http } from 'SharedDir/backend/axios/http';

import SimpleApi from 'SharedDir/backend/api/classes/simpleApi';
import { DECREE_GSM, DECREE_GSM_URL } from 'SharedDir/backend/endpoints/registry-material-resource';
import { NpaAttachBackendType, NpaAttachType } from 'SharedDir/constants/tmc-registry';
import { AttachmentsBare } from 'SharedDir/declarations/departments';
import { RegistryMaterialResource } from 'SharedDir/declarations/registry-material-resource';
import { FileBare } from 'SharedDir/declarations/shared';
import { TtpHistory } from 'SharedDir/declarations/ttp-history';
import fileDownloader from 'SharedDir/utils/file-downloader';

export default class DecreeGsmApiClass extends SimpleApi<
  RegistryMaterialResource.DecreeGsmFull,
  RegistryMaterialResource.DecreeGsmCreate,
  RegistryMaterialResource.DecreeGsmUpdate,
  RegistryMaterialResource.DecreeGsmBare
> {
  constructor() {
    super(DECREE_GSM_URL);
  }

  protected readonly endpoints = DECREE_GSM;

  public async getHistory(id: number, params: any) {
    const endpoint = this.endpoints.HISTORY(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  public async getHistoryToPayment(id: number, params: any) {
    const endpoint = this.endpoints.HISTORY_TO_PAYMENT(id);

    const { data } = (await http({
      ...endpoint,
      params,
    })) as AxiosResponse<TtpHistory.HistoryItem[]>;

    return data;
  }

  async approve(npaId: string | number) {
    const url = `${DECREE_GSM_URL}/${npaId}/approve`;
    const { data: responseData } = await http({ url, method: 'post' });
    return responseData;
  }

  async removeMaterialResourceRecord(npaId: string | number, id: string | number) {
    const url = `${DECREE_GSM_URL}/${npaId}/to-payment/${id}`;
    const { data } = (await http({
      url,
      method: 'delete',
    })) as AxiosResponse<RegistryMaterialResource.NpaFull>;
    return data;
  }

  async addMaterialResourceRecord(npaId: string | number, id: string | number) {
    const url = `${DECREE_GSM_URL}/${npaId}/to-payment/${id}`;
    const { data } = (await http({
      url,
      method: 'put',
    })) as AxiosResponse<RegistryMaterialResource.NpaFull>;
    return data;
  }

  async provide(
    npaId: number,
    data: {
      providedAt: string;
    }
  ) {
    const url = `${DECREE_GSM_URL}/${npaId}/provide`;
    const { data: responseData } = await http({ url, method: 'post', data });
    return responseData;
  }

  async exportPaymentsXLSX(id: number) {
    fileDownloader.saveFileFromResponse(
      await http({ ...this.endpoints.EXPORT_PAYMENTS_XLSX(id), responseType: 'blob' })
    );
  }

  async exportPersonsXLSX(id: number, data) {
    fileDownloader.saveFileFromResponse(
      await http({ ...this.endpoints.EXPORT_PERSONS_XLSX(id), data, responseType: 'blob' })
    );
  }

  async exportXML(id: number, bankId: number) {
    const params = {
      bankId,
      fileName: 'Выгрузка по сберу',
    };

    fileDownloader.saveFileFromResponse(await http({ ...this.endpoints.EXPORT_XML(id), params }));
  }
}
